<app-window [title]="title">
    <form role="form" id="detailForm" *ngIf="record">
        <div class="row">
            <div class="col-sm-4">
                <div class="form-group">
                    <label>Valido dal</label>
                    <div class="input-group" >
                        <input class="form-control" type="date"  name="date_from"  [(ngModel)]="record.date_from"  />
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="form-group">
                    <label>Valido al</label>
                    <div class="input-group" >
                        <input class="form-control" type="date"  name="date_to"  [(ngModel)]="record.date_to"  />
                    </div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="form-group">
                    <label>Stato</label>
                    <select class="form-control" name="state" [(ngModel)]="record.state">
                        <option value="1">Continua a riproporre</option>
                        <option value="2">Non riproporre più</option>
                        <option value="3">Annullato</option>                        
                    </select>        
                </div>
            </div>
            <div class="col-sm-12">
                <div class="form-group">
                    <label>Anagrafica</label>
                    <div class="input-group">
                        <input type="text" class="form-control" readonly="true" name="addressname" [(ngModel)]="record.addressname">
                        <div class="input-group-append">
                            <button class="btn btn-sm" (click)="selectAddress()">Scegli</button>
                        </div>
                    </div>                    
                </div>                    
            </div>            
        </div>        
        <div class="row">
            <div class="col-sm-12">
                <div class="form-group">
                    <label>Descrizione</label>
                    <div class="input-group" >
                        <textarea class="form-control form-control-sm"  name="description"  [(ngModel)]="record.description" ></textarea>
                    </div>
                </div>
            </div>
        </div>        
    </form>
    <app-toolbarmodel [model]="this"></app-toolbarmodel>
</app-window>